import FormikHomeAssumptionsZurichRentPage from './FormikHomeAssumptionsZurichRentPage';

export default FormikHomeAssumptionsZurichRentPage;
